import React from 'react';
import { Outlet } from 'react-router-dom';
import './SettingsMobile.css'
import NavPagesMobile from './NavPagesMobile';
import SettingsLogic from './SettingsLogic';


function SettingsMobile() {
    const { activeTab, handleTabChange } = SettingsLogic();

    return (
        <div className='mb-setting'>
            <div className='setting-mobile-header'>
                <h5 className='setting-mobile-header-text'>Settings</h5>
            </div>
            <div className="row">
                <div className="col-md-3 ">
                    <NavPagesMobile activeTab={activeTab} handleTabChange={handleTabChange} />
                </div>
                <div className="col-md-9">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default SettingsMobile;
